
// import '/home/azhar/phase-3-project-frontend/src/App.css';
import React from 'react';
import { useState,useEffect, } from 'react';
import { Route,Routes } from 'react-router-dom';
import NavBar from './NavBar';
import CarsList from './CarsList';
import Log from './Log';
import About from './About';
import Login from './Login';
import BuyNow from './BuyNow';
// import Manufacturers from './Manufacturers';

function App() {
  const[data,setData]=useState([])
 function fetching(){

  fetch("https://valetroni-api.onrender.com/cars")
  .then(resp=>resp.json())
  .then(data=>{
   console.log(data)
   setData(data)
  })
}
useEffect(()=> fetching(),[])
function posting(information){
  fetch("https://valetroni-api.onrender.com/add_customer",{
    method:"POST",
    headers:{
      "content-type":"Application/json"
    },
    body:JSON.stringify(information)
  })
  .then(resp=>resp.json())
  .then(data=>console.log(data))
  .catch(error=>console.log(error))
}
function patching(id,newData){
  fetch(`https://valetroni-api.onrender.com/car_update/${id}`,{
    method:"PATCH",
    headers:{
        "Content-Type":"Application/json"
    },
    body:JSON.stringify(newData)
 })
 .then(resp=>resp.json())
 .then(data=>{
  fetching()
  console.log(data)})
}
function deleting(id){
  fetch(`htps://valetroni-api.onrender.com//delete_car/${id}`,{
    method:"DELETE",
    headers:{
      "Content-Type":"Application/json"
    }
  })
  .then(resp=>resp.json())
  .then(data=>{ 
    console.log(data)
  })
}




  return (
    <div className="App">
      <Log/>
      <NavBar/>
      <Routes>
        <Route path='/home' element={<CarsList data={data} patching={patching} fetching={fetching}/>}/>
        <Route path='/about' element={<About/>}/>
        <Route path='/login' element={<Login posting={posting}/>}/>
        <Route path='/buy_car' element={<BuyNow data={data} fetching={fetching} patching={patching} deleting={deleting}/>} />
        {/* <Route path='manufacturers' element={<Manufacturers/>}/> */}
      </Routes>
    </div>
      
  );
}

export default App;
